@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.pill {
  display: inline-flex;
  height: 22px;
  padding: 2px 6px;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--dark-3);
  color: var(--dark-80);
  text-align: center;
  @include sm-sohne;
  border: 1px solid var(--dark-4);

  &.xs {
    border-radius: 4px;
    font-size: 12px;
    line-height: 110%;
    letter-spacing: 0.24px;
    height: 18px;
    padding: 1px 3px 2px 3px;
  }

  &.sm {
    @include xs-sohne-book;
    border-radius: 4px;
  }

  &.md {
    height: 24px;
    padding: 4px 8px;
    border-radius: 6px;
  }

  &.lg {
    height: 33px;
    padding: 6px 9px;
    border-radius: 8px;
  }

  &.xl {
    @include md-sohne;
    height: 36px;
    padding: 6px 12px;
    border-radius: 8px;
  }

  &.xxl {
    @include md-sohne;
    height: 40px;
    padding: 8px 14px;
    border-radius: 10px;
  }
}
